export const LOGIN_EMAIL = 'LOGIN_EMAIL'
// export const ACTIVATE_TEXT = 'ACTIVATE_TEXT'
// export const UPDATE_TRANSCRIPT = 'UPDATE_TRANSCRIPT'
// export const AUDIO_PLAYING = 'AUDIO_PLAYING'
// export const AUDIO_SET_TIME = 'AUDIO_SET_TIME'
export const SET_SUBSCRIPTION_STATUS = 'SET_SUBSCRIPTION_STATUS'
export const SET_STREAM = 'SET_STREAM'
